import { useAppBridge } from "@shopify/app-bridge-react";
import { queryOptions } from "@tanstack/react-query";

export const ShopUserQuery = () =>
  queryOptions({
    queryFn: async () => {
      const shopify = useAppBridge();
      return (await shopify.user()) as {
        accountAccess?: string;
        email?: string;
        id?: number;
        name?: string;
      };
    },
    queryKey: ["shopUser"],
  });
